import * as React from "react";
import { UitkCard, UitkCardImageLayout, UitkCardMedia, UitkCardContent, UitkCardTextSegment } from "uitk-react-cards";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { AttachSavingsCardProps } from "../typings";
import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "../l10n";
import { SavingsContent } from "./SavingsContent";

export const AttachSavingsCard = (props: AttachSavingsCardProps) => {
  const { formatText } = useLocalization();

  return (
    <UitkCard imageLayout={UitkCardImageLayout.LEFT_FULLBLEED} withBorder={props.withBorder}>
      <UitkCardMedia className="s-x-padding-six s-y-padding-six m-x-padding-six m-y-padding-six all-x-padding-twelve all-y-padding-twelve">
        <UitkFigure className="all-image-fit-contain" ratio={UitkFigure.AspectRatio.R16_9}>
          <UitkImage
            alt={formatText(locKeys.savingsTitle)}
            src="https://a.travel-assets.com/flex/flexmanager/images/2019/11/21/illustration__treasure__sml.svg"
          />
        </UitkFigure>
      </UitkCardMedia>
      <UitkCardContent>
        <UitkCardTextSegment className="uitk-flex uitk-flex-column uitk-flex-justify-content-center uitk-flex-align-items-flex-start">
          <SavingsContent
            deepLink={props.deepLink}
            deepLinkMipType={props.deepLinkMipType}
            moduleName={props.moduleName}
            percentageOff={props.percentageOff}
          />
        </UitkCardTextSegment>
      </UitkCardContent>
    </UitkCard>
  );
};

export default AttachSavingsCard;
